 

<template>

  <div class="modal fade light " id="modalDeposit" ref="bank" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-background modal-lg">
      <div class="modal-content">
        <div class=" ">
          <header class="modal-card-head">
            <p class="modal-card-title">บัญชีสำหรับโอนเข้าเติมเงิน</p><button aria-label="close" data-dismiss="modal"
              class="delete"></button>
          </header>
          <section class="modal-card-body">
            <div class="my-account">
              <div class="bank-detail">
                <div class="note"> บัญชีที่ใช้เติมเงิน จะต้องเป็นบัญชีด้านล่างนี้เท่านั้น <br><span>(โดยเงินจะถูกโอนเข้า
                    Wallet ภายใน 1 นาที)</span></div>
                <div class="bank-name-th"> {{ getBankName(UserInfo.BankCode) }} </div>
                <div class="account-name m-t-10"> {{
                  UserInfo.userName.fullName
                }} </div>
                <div class="account-no"> {{ UserInfo.BankAccount | formatAccNo }} <i
                    @click="copyBack(UserInfo.BankAccount)" class="fas fa-copy m-l-10"></i>
                </div>
              </div>
            </div>
            <div class="field-group section-title m-b-5"><span>บัญชีสำหรับโอนเข้าเติมเงิน</span></div>
            <div class="section-subtitle m-t-10 m-b-5"> ธนาคาร </div>
            <div v-for="(item, index) in ChBankAll" :key="`ch-${index}`">
              <div><!---->
                <div class="account " :style="{
                  'background-color': getBankColorwithCode(item.BankCode),
                }" :class="{
  'truewallet': item.BankCode == 'co.th.truemoney.wallet'
}">
                  <div>
                    <div class="columns is-mobile">
                      <div class="column is-5 is-one-third-mobile text-center"><img
                          v-bind:src="getBankImgwithCode(item.BankCode)" width="100"></div>

                      <div class="column is-7 is-two-third-mobile">

                        <div class="bank-detail">
                          <div class="bank-name-th"> {{
                            getBankName(item.BankCode)
                          }} </div>
                          <div class="account-name m-t-10"> {{
                            item.fullName
                          }} </div>
                          <div class="account-no"> {{ item.BankAccount }} <i id="kbankAuto"
                              @click="copyBack(item.BankAccount)" class="fas fa-copy m-l-10"></i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div><!----><!----><!---->
              </div>
            </div>

          </section>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'
import { fetchBank } from '@/services/modules/deposit.js'
import moment from 'moment'
import DepositFormAuto from '@/components/form/DepositFormAuto'
import DepositFormTrue from '@/components/form/DepositFormTrue'
import { PrefixMixins } from '@/mixins/Prefix.js'
import { BankMixins } from '@/mixins/BankService.js'
export default {
  name: 'DepositForm',
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      // deposit
      ChAuto: [],
      ChBankTrue: [],
      ChBankAll: [],
    }
  },
  components: {
    DepositFormAuto,
    DepositFormTrue,
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'getPrefix',
    ]),
  },
  methods: {
    getDate: function (data) {
      return moment(data).format('DD MMMM YYYY, h:mm:ss a')
    },
    async copyBack(item) {
      this.$copyText(item, this.$refs.bank)
      this.$swal.fire('คัดลอกแล้ว', '', 'success')
    },
    async fetchBank() {
      await fetchBank((res) => {
        if (res.status) {
          this.ChBankTrue = res.data.ChBankTrue
          this.ChAuto = res.data.ChAuto
          this.ChBankAll = res.data.All
        } else {
        }
      })
    },
  },
  async mounted() {
    await this.fetchBank()
  },
}
</script>
<style scoped>
.leftdps .nav-link {
  color: #fff;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff;
  background-color: #26436d;
}
</style>



// WEBPACK FOOTER //
// src/components/form/DepositForm.vue